export default __webpack_public_path__ + "static/media/sorticon.2d8628ca.svg";